<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="input-group input-group-sm" style="width: 250px;">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">Export
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 300px;">
            <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right"
              placeholder="Search">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>

            <select type="text" name="table_search" [(ngModel)]="sortby" class="form-control float-right">
              <option value="pltNo">Plt No</option>
              <!-- <option value="area">Area</option> -->
              <option value="status">Status</option>
            </select>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-sort"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0" style="height: 410px;">
        <table class="table table-head-fixed text-nowrap">
          <thead>
            <tr>
              <th>Plt No</th>
              <th>Area</th>
              <th>Status</th>
              <th>length</th>
              <th>width</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plt of pltData | filter: searchString: 'status' | sort: [ sortby,''] ">
              <td>{{ plt.plot_number }}</td>
              <td>{{ plt.length * plt.width }}</td>
              <td>{{ plt.status }}</td>
              <td>{{ plt.length }}</td>
              <td>{{plt.width}}</td>
              <td>
                <a class="btn" (click)="info(plt.plot_number)"><i class="fas fa-info"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>
</div>



<!-- Button trigger for Details modal -->
<button style="display: none;" type="button" id="sales-info-btn" class="btn btn-primary" data-toggle="modal" data-target="#salesDetailsModal">
  create new property HIDEN
</button>

<!-- Details Modal -->
<div class="modal fade" id="salesDetailsModal" tabindex="-1" role="dialog" aria-labelledby="salesDetailsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="salesDetailsModalTitle">Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table" *ngIf="plotDetails">
          <thead>
            <tr>
              <th scope="col">Plot No.</th>
              <th scope="col">{{plotDetails.plot_number}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Length</th>
              <td>{{plotDetails.length}}</td>
            </tr>
            <tr>
              <th scope="row">Width</th>
              <td>{{plotDetails.width}}</td>
            </tr>
            <tr>
              <th scope="row">Area</th>
              <td>{{plotDetails.length * plotDetails.width}}</td>
            </tr>
            <tr>
              <th scope="row">Status</th>
              <td>{{plotDetails.status}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
